<template>

<div id="credits-container">

  <BackComponent />

  <div id="credits" v-html="$i18n.t('galleryCredits')"></div>
</div>

</template>



<script>

import {loadLocaleMessages} from "../i18n.js";
import BackComponent from "./BackComponent.vue";
export default { 
  name: "CreditsPage",
  components: {
    BackComponent: BackComponent,
  },
  data() {
    return{
      dxaFull: process.env.VUE_APP_DXA_FULL,
    }
  },
  // Load i18n messages in correct language
  beforeRouteEnter(to, from, next) {
    loadLocaleMessages("en").then(() => next()); 
  },
  beforeRouteUpdate(to, from, next) {
    loadLocaleMessages("en").then(() => next());
  }
}

</script>



<style scoped lang="scss">

#credits-container {
  @include flex-center;
  flex-direction: column;
  background-color: white;
  width: 100%;
}

#back {
  @include flex-center;
  justify-content: flex-start;
  height: 50px;
  width: 100%;
  padding-top: 30px;
  padding-left: 50px;
}
  #back .fas {
    font-size: 75%;
    padding-right: 4px;
  }
  #back button {
    @include button-styles;
    padding: 2px;
    font-weight: bold;
  }

#credits {
  width: 50%;
  padding: 50px 50px 100px 50px;
}
  #credits a {
    @include link-styles;
    overflow-wrap: break-word;
    word-break: break-all;
  }
    #credits a:hover {
      @include link-hover-styles;
    }

@media only screen and (max-width: 1199px) {
  #credits {
    width: 70%;
  }
}

@media only screen and (max-width: 974px) {
  #credits {
    width: 80%;
  }
}

@media only screen and (max-width: 849px) {
  #credits {
    width: 88%;
  }
}

@media only screen and (max-width: 724px) {
  #credits {
    width: 100%;
  }
}

@media only screen and (max-width: 599px) {
  #back {
    padding-left: 30px;
  }
  #credits {
    padding: 30px 30px 50px 30px;
  }
  .break {
    padding-bottom: 10px;
  }
}

@media only screen and (max-width: 499px) {
  #team-container p {
    margin-bottom: 5px;
  }
}

@media only screen and (max-width: 399px) {
  #team-container p {
    margin-bottom: 8px;
  }
}

</style>